/*
 * Load the BundleInformation object into the queued bundle card HTML element
 *
 * @param {object} queued_plan_card - The queued plan card 2 HTML element
 * @param {object} bundle_info - The BundleInformation object
 * */
function loadQueuedPlanCardInformation(
  queued_plan_card,
  bundle_info,
  use_lowercase_units = false,
  sizeOfAGigabyte = 1000000000
) {
  let unit = window.esimCardStrings.gigabyte;

  let parts = bundle_info.description.split(",");
  let country;
  let duration;

  if (parts.length >= 4 && parts[3].trim()) {
    country = parts[3].trim();

    let durationSplit = parts[2].trim().split(" ");
    if (parseInt(durationSplit[0]) > 0) {
      duration = durationSplit[0];
    }
  } else {
    country = window.esimDetailsStrings.bundleQueued;
  }

  if (bundle_info.assignment.unlimited) {
    queued_plan_card.querySelector("#queued_plan_card_data").textContent = window.esimCardStrings.unlimitedBundle;
  } else {
    queued_plan_card.querySelector("#queued_plan_card_data").textContent =
      (bundle_info.assignment.initialQuantity / sizeOfAGigabyte).toString() + " " + unit;
  }

  if (duration) {
    queued_plan_card.querySelector("#queued_plan_card_duration").textContent = `${duration} ${
      queued_plan_card.querySelector("#queued_plan_card_duration").textContent
    }`;
  } else {
    queued_plan_card.querySelector("#queued_plan_card_duration_container").style.display = "none";
    queued_plan_card.querySelector(".queued_plan_card_details_table_row_divider").style.display = "none";
  }

  queued_plan_card.querySelector("#queued_plan_card_title").textContent = country;
}
